import { render, staticRenderFns } from "./ModeratorMonthlyTab.vue?vue&type=template&id=02b1d229&"
import script from "./ModeratorMonthlyTab.vue?vue&type=script&lang=js&"
export * from "./ModeratorMonthlyTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports